import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-auth-signin-form',
  templateUrl: './auth-signin-form.component.html',
  styleUrls: ['./auth-signin-form.component.scss'],
})
export class AuthSigninFormComponent {
  auth_signin_form_group: FormGroup = this.form_service.auth_signin_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_password_visible: boolean = false;

  constructor(private form_service: FormService, private navigation_service: NavigationService) {}

  onSigninClick(): void {}

  onSignupRedirectClick(): void {
    this.navigation_service.toAuthSignup();
  }
}
